import React from 'react';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  error?: string;
  required?: boolean;
  helperText?: string;
  className?: string;
}

export function FormField({
  label,
  children,
  error,
  required = false,
  helperText,
  className = '',
}: FormFieldProps) {
  return (
    <div className={`form-group space-y-1.5 ${className}`}>
      <label className="block text-sm font-medium text-[#1D314D]">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
      {helperText && !error && (
        <p className="text-xs text-slate-500 mt-1">{helperText}</p>
      )}
      {error && <p className="error-message text-sm text-red-500 mt-1">{error}</p>}
    </div>
  );
}
